import { prop, pick } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setCookie } from 'js/utils/cookie.util';
import { COOKIE_SETTINGS_REDUCER } from 'js/store/constants';
import { storageService } from 'js/services/storage.service';
import { useAppSelector, useCustomSelector } from 'js/store/hooks';
import { useShowNotification } from 'js/components/common/Notifications';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

import * as actions from '../store/actions';

export const useSubmitCookies = ({ translate }) => {
    const dispatch = useDispatch();
    const showNotification = useShowNotification();
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();
    const {
        groupsData,
        defaultCookieName,
        storageCookieName,
        cookieExpirationDays
    } = useCustomSelector(COOKIE_SETTINGS_REDUCER, pick(['groupsData', 'defaultCookieName', 'storageCookieName', 'cookieExpirationDays']));
    const { commonCookieName = defaultCookieName } = useAppSelector(prop('cookiesConfiguration'));

    return useCallback((formData) => {
        const isAnyGroupChanged = Object.keys(groupsData).some((key) => groupsData[key] !== formData[key]);

        storageService.local.setItem(storageCookieName, formData);
        setCookie(commonCookieName, 1,
            { expires: cookieExpirationDays, path: '/' });

        dispatch(actions.setCommonCookieFlag(true));
        publicEventsAPIService.trigger('cookieMessageClosed');

        showNotification({ message: translate('submit.success') });
        navigateToPopupBackgroundPage();

        if (!isAnyGroupChanged) {
            return;
        }

        dispatch(actions.setCookiesGroups(formData));
    }, [
        dispatch, translate, groupsData, showNotification, commonCookieName,
        storageCookieName, cookieExpirationDays, navigateToPopupBackgroundPage
    ]);
};
